<h3 style="text-align: center;">{{ui.title}}</h3>
<div table-line-chart-widget="" row="ui.row" history-time="ui.historyTime" style="height:500px"></div>
